import { render, staticRenderFns } from "./ActivityAlert.vue?vue&type=template&id=4d87d33a"
import script from "./ActivityAlert.vue?vue&type=script&lang=js"
export * from "./ActivityAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports